import { get, patch } from '@/api/base'

const routeStopReactions = {
  get: async params => {
    const response = await get({ path: 'routes/stops/reactions', params })

    return response.success ? response.data.reactions : []
  },
  update: async params => {
    await patch({ path: 'routes/stops/reactions', params })
  },
}

export default routeStopReactions
